(function(){"use strict";var e;try{if(typeof document<"u"){var r=document.createElement("style");r.nonce=(e=document.head.querySelector("meta[property=csp-nonce]"))==null?void 0:e.content,r.appendChild(document.createTextNode("._host_guhku_1{display:flex;height:0}._divider_guhku_6{margin-top:unset;margin-bottom:unset;border:none;width:100%;display:inline-block}._solid-light-gray_guhku_13{border-bottom:.0625rem solid var(--grey-200-ee)}._solid_guhku_13{border-bottom:.0625rem solid var(--grey-400-cc)}._dashed_guhku_21{border-bottom:.0625rem dashed var(--grey-400-cc)}._dotted_guhku_25{border-bottom:.0625rem dotted var(--grey-400-cc)}._solid-light-gray_guhku_13._vertical_guhku_29{border-left:.0625rem solid var(--grey-200-ee);height:15.625rem}._solid_guhku_13._vertical_guhku_29{border-left:.0625rem solid var(--grey-400-cc);height:15.625rem}._dashed_guhku_21._vertical_guhku_29{border-left:.0625rem dashed var(--grey-400-cc);height:15.625rem}._dotted_guhku_25._vertical_guhku_29{border-left:.0625rem dotted var(--grey-400-cc);height:15.625rem}._link_105os_1{-webkit-text-decoration:underline;text-decoration:underline;cursor:pointer}._defaultFont_105os_6{font-family:var(--font-families-verdana);font-size:var(--font-size-2);font-weight:var(--font-weights-verdana-regular);line-height:var(--line-heights-auto)}._primary_105os_13{color:var(--grey-700-66, #666)}._primary_105os_13:hover{color:var(--primary-red-700)}._secondary_105os_21{color:var(--grey-800-33, #333)}._secondary_105os_21:hover{color:var(--primary-red-700)}._tertiary_105os_29{color:var(--primary-red-500)}._tertiary_105os_29:hover{color:var(--primary-red-700)}._quaternary_105os_37{color:var(--primary-yellow, #666)}._quaternary_105os_37:hover{color:var(--primary-orange)}._link_105os_1:focus-visible{outline:.125rem var(--focus-style) var(--primary-orange, #d68726);outline-offset:-.0625}._button_11grq_1{display:flex;justify-content:center;align-items:center;cursor:pointer;text-align:center;font-family:var(--font-families-verdana);font-size:var(--font-size-2);font-style:normal;font-weight:var(--font-weights-verdana-regular);line-height:var(--line-heights-16);border:.063rem solid transparent;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}._buttonIcon_11grq_16{max-width:var(--m);max-height:var(--m)}._button_11grq_1:focus-visible{border:.063rem var(--focus-style) var(--focus-color, #d68726);outline:none}._small_11grq_26{gap:.25rem;padding:.75rem 2rem}._big_11grq_32{gap:.375rem;padding:var(--s) var(--l)}._full_11grq_37{width:100%}._primary_11grq_41{background-color:var(--primary-red-500);color:var(--neutrals-white)}._primary_11grq_41:hover{background-color:var(--primary-red-600)}._secondary_11grq_50{color:var(--primary-red-500, #d7192d);border:.063rem solid var(--primary-red-500, #d7192d);background:var(--neutrals-white, #fff)}._secondary_11grq_50:hover{color:var(--primary-red-700, var(--primary-red-700, #a8191a));border:.063rem solid var(--primary-red-700, #a8191a);background:var(--neutrals-white, #fff)}._text_11grq_62{-webkit-text-decoration:underline;text-decoration:underline;color:var(--grey-800-33, #333);background:inherit;padding:0;border:none}._text_11grq_62:hover{-webkit-text-decoration:underline;text-decoration:underline;color:var(--primary-red-700-66, #a8191a);background:inherit}._text_11grq_62:focus-visible{outline:.125rem var(--focus-style) var(--primary-orange, #d68726);outline-offset:-.0625;border:none}._black_11grq_83{color:var(--neutrals-white, #fff);background-color:var(--grey-700-66, #666)}._black_11grq_83:hover{color:var(--neutrals-white, #fff);background-color:var(--grey-800-33, #333)}._button_11grq_1:disabled{cursor:not-allowed;color:var(--neutrals-white, #fff);background-color:var(--grey-400-CC, #666)}._button_11grq_1:disabled:hover{cursor:not-allowed;color:var(--neutrals-white, #fff);background-color:var(--grey-400-CC, #666)}._button_11grq_1:disabled._text_11grq_62,._button_11grq_1:disabled:hover._text_11grq_62{color:var(--grey-400-CC, #666);background-color:inherit}")),document.head.appendChild(r)}}catch(o){console.error("vite-plugin-css-injected-by-js",o)}})();
import { jsx as d, jsxs as b } from "react/jsx-runtime";
import m from "react";
import { clsx as u } from "clsx";
import { I as h } from "./Icon-COuuXGxa.js";
const p = "_host_guhku_1", k = "_divider_guhku_6", q = "_solid_guhku_13", v = "_dashed_guhku_21", I = "_dotted_guhku_25", x = "_vertical_guhku_29", g = {
  host: p,
  divider: k,
  "solid-light-gray": "_solid-light-gray_guhku_13",
  solid: q,
  dashed: v,
  dotted: I,
  vertical: x
}, N = m.forwardRef(
  ({ className: o, vertical: t = !1, variant: r = "solid-light-gray", ...a }, s) => /* @__PURE__ */ d(
    "hr",
    {
      ref: s,
      "aria-orientation": t ? "vertical" : "horizontal",
      className: u(g.divider, g[r], { [g.vertical]: t }, o),
      ...a
    }
  )
);
N.displayName = "IbDividerDigital";
const D = "_link_105os_1", F = "_defaultFont_105os_6", R = "_primary_105os_13", $ = "_secondary_105os_21", w = "_tertiary_105os_29", B = "_quaternary_105os_37", n = {
  link: D,
  defaultFont: F,
  primary: R,
  secondary: $,
  tertiary: w,
  quaternary: B
}, j = m.forwardRef(
  ({ children: o, link: t, variant: r = "primary", rel: a = "noopener noreferrer", defaultStyles: s, className: i, titleLink: e, ...l }, c) => t === void 0 ? /* @__PURE__ */ d(
    "span",
    {
      ref: c,
      title: e,
      className: u(n.link, n[r], s && n.defaultFont, i),
      ...l,
      children: o
    }
  ) : /* @__PURE__ */ d(
    "a",
    {
      ref: c,
      href: t,
      rel: a,
      title: e,
      className: u(n.link, n[r], s && n.defaultFont, i),
      ...l,
      children: o
    }
  )
);
j.displayName = "LinkDigital";
const C = "_button_11grq_1", L = "_buttonIcon_11grq_16", z = "_small_11grq_26", A = "_big_11grq_32", E = "_full_11grq_37", G = "_primary_11grq_41", H = "_secondary_11grq_50", J = "_text_11grq_62", K = "_black_11grq_83", _ = {
  button: C,
  buttonIcon: L,
  small: z,
  big: A,
  full: E,
  primary: G,
  secondary: H,
  text: J,
  black: K
}, M = m.forwardRef(
  ({
    children: o,
    as: t = "button",
    disabled: r = !1,
    buttonSize: a = "big",
    variant: s = "primary",
    full: i = !1,
    icon: e,
    type: l = "button",
    className: c,
    ...y
  }, f) => /* @__PURE__ */ b(
    t,
    {
      ref: f,
      className: u(_.button, _[a], _[s], i && _.full, c),
      disabled: r,
      type: l,
      ...y,
      children: [
        e && /* @__PURE__ */ d(h, { className: _.buttonIcon, name: e }),
        o
      ]
    }
  )
);
M.displayName = "ButtonDigital";
export {
  M as B,
  N as I,
  j as L
};
